module.exports = __webpack_public_path__ + "img/pr-5.b3173a35.png";